import { render, staticRenderFns } from "./TestQuestionMultiple.vue?vue&type=template&id=6298e53c&scoped=true"
import script from "./TestQuestionMultiple.vue?vue&type=script&lang=js"
export * from "./TestQuestionMultiple.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6298e53c",
  null
  
)

export default component.exports